import type { FlotiqStore, OtherStore } from "@jti/fe-common";
import { OTHER_STORES } from "@jti/fe-common";

export function isPartnerStore(store: FlotiqStore) {
  if (store.storetype) {
    return OTHER_STORES.includes(store.storetype as OtherStore);
  }

  return false;
}
